import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Checkbox from "carbon-components-react/lib/components/Checkbox";
import RotatableImage from "../../components/rotatableImage";

export default function AnswerMatchView(props) {
  const { t, i18n } = useTranslation("kunduz");
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    document.addEventListener("keydown", hotKeyListener);
    return function cleanup() {
      document.removeEventListener("keydown", hotKeyListener);
    };
  }, []);

  function hotKeyListener(e) {
    switch (e.key) {
      case "m":
        if (selectedTags.length > 0) {
          props.saveCallback(selectedTags);
        } else {
          alert("Lütfen cevap görseliyle ilgili bir bilgi seçiniz");
        }
        break;
      default:
        break;
    }
  }

  function toggleTag(tagID) {
    const i = selectedTags.indexOf(tagID);
    if (i > -1) {
      selectedTags.splice(i, 1);
      setSelectedTags(selectedTags);
    } else {
      selectedTags.push(tagID);
      setSelectedTags(selectedTags);
    }
  }

  const { answer } = props;

  return (
    <div className="">
      <div className="flex-line flex-jcsb flex-aic">
        <span className="answer-title">{t("suggestedAnswer")}</span>
        <span className="answer-secondary">
          {answer && new Date(answer.answer_time).toLocaleString()}
        </span>
      </div>
      <div
        className="flex-line flex-jcsb flex-aic"
        style={{ marginTop: "16px" }}
      >
        <span className="answer-title2">
          {answer && answer.subject ? answer.subject : "N/A"}
        </span>
        <span className="answer-title2">#{answer ? answer.id : ""}</span>
      </div>
      <div
        className="flex-line flex-jcsb flex-aic"
        style={{ marginTop: "16px" }}
      >
        <span className="answer-title2">
          {t("feedbackRate")}:{" "}
          {answer && answer.feedback_rate ? answer.feedback_rate : "N/A"}
        </span>
      </div>

      {answer ? (
        <RotatableImage src={answer.media.original} side={props.side} />
      ) : null}

      <div className="action-wrapper" style={{ marginTop: 16 }}>
        {props.tags.map((tag, index) => {
          return (
            <Checkbox
              key={index}
              labelText={tag.name}
              id={`cb-${index}`}
              defaultChecked={false}
              onChange={() => {
                toggleTag(tag.id);
              }}
            />
          );
        })}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            className="bx--btn bx--btn--tertiary btn--kunduz"
            type="button"
            onClick={(e) => {
              if (selectedTags.length > 0) {
                props.saveCallback(selectedTags);
              } else {
                alert("Lütfen cevap görseliyle ilgili bir bilgi seçiniz");
              }
            }}
            disabled={!props.answer || props.inProgress}
          >
            {t("save")}
          </button>
        </div>
      </div>
    </div>
  );
}
